import React from "react";
import { Stack } from "@mui/material";

import { HubHookFormPartSelect, HubHookFormSwitch } from "../../components";

const MergePartForm = ({ disabled = false }) => {
  return (
    <Stack width="100%" gap="15px">
      <HubHookFormPartSelect
        name="partId"
        label="Main Part"
        disabled={disabled}
        disableCloseOnSelect={false}
      />
      <HubHookFormPartSelect
        name="mergeParts"
        label="Parts to Merge"
        multiple
        disabled={disabled}
        disableCloseOnSelect={false}
      />
      <HubHookFormSwitch
        name="confirm"
        label="I confirm these changes cannot be undone"
        labelPlacement="end"
        disabled={disabled}
        isCheckbox
        required
      />
    </Stack>
  );
};

export default MergePartForm;
